<template>
  <a-modal
    title="上传附件"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :destroyOnClose="true"
    @cancel="handleCancel">
    <p v-if="matchInfo.notesDes">附件须知：{{ matchInfo.notesDes }}</p>
    <a-table :columns="columns" :data-source="data" size="small" :pagination="false">
      <a-tag :color="text == 1 ? 'blue' : 'pink'" slot="sex" slot-scope="text">{{ text == 1 ? '男' : '女' }}</a-tag>
      <template v-for="(enclosure, index) in enclosureData.players[0].enclosures" :slot="enclosure.name" slot-scope="text, record">
        <div :key="index" >
          <a-upload
            name="file"
            :action="imgurl"
            listType="text"
            :showUploadList="false"
            @change="handleChangeImage($event, getEnclosure(record, enclosure.name))">
            <img :src="getEnclosure(record, enclosure.name).url || defaultEnclosure" style="width:32px;height:32px;">
          </a-upload>
        </div>
      </template>
    </a-table>
    <div slot="footer">
      <a-button @click="handleCancel" v-if="!showJumpBtn">取消</a-button>
      <a-button @click="jump" v-if="showJumpBtn">跳过</a-button>
      <a-button type="primary" @click="handleOk">提交</a-button>
    </div>
  </a-modal>
</template>
<script>
import store from '@/store'
import config from '@comm/http/config'
const columns = [
  { title: '队员姓名', dataIndex: 'name', align: 'center' },
  { title: '性别', dataIndex: 'sex', align: 'center' },
  { title: '附件', dataIndex: 'enclosures', scopedSlots: { customRender: 'enclosures' }, align: 'center' }
]
export default {
  data () {
    return {
      cancelText: '取消',
      imgurl: config.baseImgURL,
      visible: false,
      confirmLoading: false,
      matchId: this.$route.query.matchId,
      agencyId: this.$route.query.agencyId,
      defaultEnclosure: require('@comm/assets/join/add_img.png'),
      defaultHead: require('@comm/assets/join/photo.png'),
      enclosureData: { players: [{ enclosures: [] }] },
      columns: columns,
      matchInfo: store.getters['match/matchInfo'],
      data: [],
      joinData: null,
      showJumpBtn: false
    }
  },
  methods: {
    handleOk () {
      let result = this.checkEnclosure()
      if (!result) {
        return
      }
      this.saveEnclosureBatch(result)
    },
    handleCancel () {
      this.visible = false
      this.joinData = null
      this.data = null
    },
    jump () {
      this.$emit('jump', this.joinData)
      this.handleCancel()
    },
    show (data, joinData) {
      if (data.canJump) {
        this.showJumpBtn = true
      } else {
        this.showJumpBtn = false
      }
      this.columns = data.tableColumns
      this.enclosureData = data
      this.data = data.players
      this.joinData = joinData
      this.visible = true
    },
    handleChangeImage (info, record) {
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      if (fileList[0].response) {
        record.url = fileList[0].response.data.url
        this.$forceUpdate()
      }
    },
    getEnclosure (record, enclosureName) {
      let enclosures = record.enclosures
      for (let i = 0; i < enclosures.length; i++) {
        let name = enclosures[i].name
        if (name === enclosureName) {
          return enclosures[i]
        }
      }
    },
    saveEnclosureBatch (params) {
      this.confirmLoading = true
      this.$api.join.saveEnclosureBatch(params).then(res => {
        if (res.status === 0) {
          this.$emit('enclosureSuccess', this.joinData)
          this.handleCancel()
        }
      }).catch(err => {
        console.log('err', err)
        this.$message.error('附件提交失败')
      }).finally(() => {
        this.confirmLoading = false
      })
    },
    checkEnclosure () {
      let params = []
      let players = this.enclosureData.players
      for (let i = 0; i < players.length; i++) {
        let player = players[i]
        let playerParam = {
          matchId: this.matchId,
          agencyId: this.agencyId,
          cardId: player.cardId,
          enclosure: null
        }
        let enclosuresParam = {}
        let hasEnclosures = false
        let enclosures = player.enclosures
        for (let j = 0; j < enclosures.length; j++) {
          let enclosure = enclosures[j]
          let url = enclosure.url
          let name = enclosure.name
          let ismust = enclosure.ismust
          if (ismust === 1 && url == null) {
            this.$message.warning(player.name + enclosure.name + '未上传')
            return false
          }
          if (url != null) {
            enclosuresParam[name] = url
            hasEnclosures = true
          }
        }
        if (hasEnclosures) {
          playerParam.enclosure = JSON.stringify(enclosuresParam)
        }
        params.push(playerParam)
      }
      return params
    }
  }
}
</script>
<style lang="scss" scoped>
  img {
    width: 45px;
    height: 45px;
  }
</style>



// WEBPACK FOOTER //
// src/comm/components/join/enclosure/AddEnclosure.vue